/* eslint-disable no-undef */
import "../assets/css/FavoritesPage.css";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { TopBarMenu } from "../components/TopBarMenu";
import { TopLeftComponent } from "../components/TopLeftComponent";
import { FavoritesPageVehiclesComponent } from "../components/FavoritesPageVehiclesComponent";
import { useGetFavoriteVoyagesByUserIdQuery } from "../slices/VoyageSlice";
import { useGetFavoriteVehiclesByUserByIdQuery } from "../slices/VehicleSlice";
import { FavoritesPageVoyagesComponent } from "../components/FavoritesPageVoyagesComponent";
import { FavoritesPlaceHolderComponent } from "../components/FavoritesPlaceHolderComponent";
import { SomethingWentWrong } from "../components/SomethingWentWrong";
import { useHealthCheckQuery } from "../slices/HealthSlice";
import { EmptyFavoritesComponent } from "../components/EmptyFavoritesComponent";
import { useSelector } from "react-redux";

export default function FavoritePage() {
  const userId = localStorage.getItem("storedUserId");
  const isDarkMode = useSelector((state) => state.users.isDarkMode);
  // console.log("userid", userId);
  const {
    data: FavoriteVoyagesData,
    isError: isFavoriteVoyagesError,
    isSuccess: isFavoriteVoyagesSuccess,
    isLoading: isFavoriteVoyagesLoading,
    refetch: refetchFavoriteVoyages,
  } = useGetFavoriteVoyagesByUserIdQuery(userId);
  const {
    data: FavoriteVehiclesData,
    isError: isFavoriteVehiclesError,
    isSuccess: isFavoriteVehiclesSuccess,
    isLoading: isFavoriteVehiclesLoading,
    refetch: refetchFavoriteVehicles,
  } = useGetFavoriteVehiclesByUserByIdQuery(userId);

  useEffect(() => {
    refetchFavoriteVoyages();
    refetchFavoriteVehicles();
  }, []);

  // useEffect(() => {
  //   if (isFavoriteVoyagesSuccess)
  //     console.log("FavoriteVoyagesData from api", FavoriteVoyagesData);
  //   if (isFavoriteVehiclesSuccess)
  //     console.log("FavoriteVehiclesData from api", FavoriteVehiclesData);
  // }, [FavoriteVehiclesData, FavoriteVoyagesData])

  const { data: healthCheckData, isError: isHealthCheckError } =
    useHealthCheckQuery();

  if (isHealthCheckError) {
    console.log(".....Health check failed.....");
    return <SomethingWentWrong />;
  }

  if (isFavoriteVoyagesError || isFavoriteVehiclesError) {
    return <SomethingWentWrong />;
  }

  return (

    <div className="App">
      <header className="App-header">
        <div className="flex mainpage_Container">
          <div className="flex mainpage_TopRow">
            <TopLeftComponent />
            <div className="flex mainpage_TopRight">
              <TopBarMenu />
            </div>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              height: "3rem",
              margin: "auto",
              marginBottom: "1rem",
              width: "90%",
            }}
          >
            <div style={{ backgroundColor: "transparent", width: "50%" }}>
              <span style={VehiclesVoyagesTitle}>Vehicles</span>
            </div>
            <div style={{ backgroundColor: "transparent", width: "50%" }}>
              <span style={VehiclesVoyagesTitle}>Voyages</span>
            </div>
          </div>

          <div className="flex favoritesPage_Bottom">
            <div className="flex favoritesPage_BottomLeft">
              <div className="flex favoritesPage_Vehicles">
                {isFavoriteVehiclesLoading || isFavoriteVoyagesLoading ? (
                  <FavoritesPlaceHolderComponent />
                ) : isFavoriteVehiclesSuccess && isFavoriteVoyagesSuccess ? (
                  FavoriteVehiclesData?.length > 0 ? (
                    <FavoritesPageVehiclesComponent
                      FavoriteVehiclesData={FavoriteVehiclesData}
                      isDarkMode={isDarkMode}
                    />
                  ) : <EmptyFavoritesComponent />
                ) : (
                  <FavoritesPlaceHolderComponent />
                )}
              </div>
            </div>
            <div className="flex flex-col favoritesPage_BottomRight">
              <div className="flex favoritesPage_Voyages">
                {isFavoriteVoyagesLoading || isFavoriteVehiclesLoading ? (
                  <FavoritesPlaceHolderComponent />
                ) : isFavoriteVoyagesSuccess && isFavoriteVehiclesSuccess ? (
                  FavoriteVoyagesData?.length > 0 ? (
                    <FavoritesPageVoyagesComponent
                      FavoriteVoyages={FavoriteVoyagesData}
                      isDarkMode={isDarkMode}
                    />
                  ) : <EmptyFavoritesComponent />
                ) : (
                  <FavoritesPlaceHolderComponent />
                )}
              </div>
            </div>
          </div>
        </div>
      </header>
    </div>
    // ) : null
  );
}


export const VehiclesVoyagesTitle = {
  width: "100%", // Added quotes around "100%"
  fontSize: "2rem", // Changed to camelCase
  fontWeight: 800, // Correct format for font-weight
  color: "white",
};
